// src/components/PhotoApp/FaceSwapPhotoBooth.jsx
import React, { useState, useRef, useEffect } from 'react';
import SiteHeader from '../SiteHeader';

// --- Mock Data ---
const templates = [
    { id: 'tpl1', name: 'ชุดไทยจักรพรรดิ', image: '/assets/templates/ชุดไทยจักรพรรดิ.jpg', gender: 'female', locationName: 'วัดเจ็ดยอด', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl2', name: 'ชุดไทยจักรี', image: '/assets/templates/ชุดไทยจักรี.jpg', gender: 'female', locationName: 'วัดเจดีย์หลวง', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl3', name: 'ชุดไทยศิวาลัย', image: '/assets/templates/ชุดไทยจิตรลดา.jpg', gender: 'female', locationName: 'วัดเชียงมั่น', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl4', name: 'ชุดไทยบรมพิมาน', image: '/assets/templates/ชุดไทยบรมพิมาน.jpg', gender: 'female', locationName: 'วัดพระธาตุดอยสุเทพ', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl5', name: 'ชุดไทยจิตรลดา', image: '/assets/templates/ชุดไทยดุสิต.jpg', gender: 'female', locationName: 'วัดพระสิงห์', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl6', name: 'ชุดไทยดุสิต', image: '/assets/templates/ชุดไทยเรือนต้น.jpg', gender: 'female', locationName: 'วัดโลกโมฬี', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl7', name: 'ชุดไทยอมรินทร์', image: '/assets/templates/ชุดไทยศิวาลัย.jpg', gender: 'female', locationName: 'วัดอุโมงค์', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl8', name: 'ชุดไทยเรือนต้น', image: '/assets/templates/ชุดไทยอมรินทร์.jpg', gender: 'female', locationName: 'ประตูท่าแพ', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl9', name: 'ชุดไทยจักรพรรดิ2', image: '/assets/templates/ชุดไทยจักรพรรดิ2.jpg', gender: 'female', locationName: 'หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl10', name: 'วัดเจ็ดยอด', image: '/assets/templates/วัดเจ็ดยอด.jpg', gender: 'male', locationName: 'วัดเจ็ดยอด', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl11', name: 'วัดพระธาตุดอยสุเทพ', image: '/assets/templates/วัดพระธาตุดอยสุเทพ.jpg', gender: 'male', locationName: 'วัดพระธาตุดอยสุเทพ', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl12', name: 'ประตูท่าแพ', image: '/assets/templates/ประตูท่าแพ.jpg', gender: 'male', locationName: 'ประตูท่าแพ', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
    { id: 'tpl13', name: 'วัดพระสิงห์', image: '/assets/templates/วัดพระสิงห์.jpg', gender: 'male', locationName: 'วัดพระสิงห์', mapUrl: 'https://maps.google.com/?q=วัดเจ็ดยอด+เชียงใหม่' },
];

const FaceSwapPhotoBooth = () => {
    const [step, setStep] = useState('intro');
    const [selectedTpl, setSelectedTpl] = useState(null);
    const [userImage, setUserImage] = useState(null);
    const [finalImage, setFinalImage] = useState(null);
    const [genderFilter, setGenderFilter] = useState('female');
    const [loadingMsg, setLoadingMsg] = useState('กำลังเตรียมการประมวลผล...');
    
    // --- State เช็ก In-App Browser (LINE, Facebook) ---
    const [isInAppBrowser, setIsInAppBrowser] = useState(false);

    // --- State สำหรับ Mini Game ---
    const [score, setScore] = useState(0);
    const [targetPos, setTargetPos] = useState({ top: '50%', left: '50%' });

    const sliderRef = useRef(null);

    // ตรวจจับเบราว์เซอร์แอปแชทเมื่อโหลดหน้าแรก
    useEffect(() => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        if (ua.indexOf('Line') > -1 || ua.indexOf('FBAV') > -1 || ua.indexOf('Instagram') > -1) {
            setIsInAppBrowser(true);
        }
    }, []);

    // --- ฟังก์ชันของ Mini Game ---
    const moveTarget = () => {
        const randomTop = Math.floor(Math.random() * 75) + 10;
        const randomLeft = Math.floor(Math.random() * 75) + 10;
        setTargetPos({ top: `${randomTop}%`, left: `${randomLeft}%` });
    };

    const handleCatchLantern = () => {
        setScore(prev => prev + 1);
        moveTarget(); 
    };

    useEffect(() => {
        let interval;
        if (step === 'processing') {
            interval = setInterval(moveTarget, 1200);
        }
        return () => clearInterval(interval);
    }, [step]);
    // ---------------------------------

    const wakeUpModel = () => {
        console.log("Sending Wake-up request to Replicate...");
        fetch("https://ebookcnx.com/api/faceswap-wakeup", { method: "POST" })
            .catch(err => console.log("Wake-up request ignored/failed", err));
    };

    const handleStartSelection = () => {
        wakeUpModel();
        setStep('select');
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const MAX_SIZE = 800;
                let width = img.width;
                let height = img.height;

                if (width > height && width > MAX_SIZE) {
                    height *= MAX_SIZE / width;
                    width = MAX_SIZE;
                } else if (height > MAX_SIZE) {
                    width *= MAX_SIZE / height;
                    height = MAX_SIZE;
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);

                const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8);
                setUserImage(compressedBase64);
                processFaceSwap(compressedBase64, selectedTpl);
            };
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    };

    const getBase64FromUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const processFaceSwap = async (sourceImageBase64, template) => {
        setStep('processing');
        setLoadingMsg('กำลังส่งข้อมูลให้ AI... 🪄');
        setScore(0); 

        try {
            let targetImageInput = template.image;
            if (template.image.startsWith('/')) {
                targetImageInput = await getBase64FromUrl(template.image);
            }

            const startResponse = await fetch("https://ebookcnx.com/api/faceswap", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    target_image: targetImageInput,
                    swap_image: sourceImageBase64,
                    action: "start"
                })
            });

            const startData = await startResponse.json();
            if (!startResponse.ok) {
                throw new Error(startData.error || "เซิร์ฟเวอร์เริ่มงานล้มเหลว");
            }

            let prediction = startData;

            if (prediction.id && prediction.status !== "succeeded") {
                setLoadingMsg('ระบบกำลังประมวลผล อาจใช้เวลาสักครู่... ⏳');
                let errorCount = 0;

                while (
                    prediction.status !== "succeeded" &&
                    prediction.status !== "failed" &&
                    prediction.status !== "canceled"
                ) {
                    await new Promise(resolve => setTimeout(resolve, 5000));

                    try {
                        const statusResponse = await fetch(`https://ebookcnx.com/api/faceswap-status?id=${prediction.id}`);

                        if (!statusResponse.ok) {
                            throw new Error(`Server responded with status ${statusResponse.status}`);
                        }

                        const currentData = await statusResponse.json();

                        if (currentData && currentData.status) {
                            prediction = currentData;
                            errorCount = 0;

                            if (prediction.status === "processing") setLoadingMsg('AI กำลังสลับใบหน้า... 🎨');
                            if (prediction.status === "starting") setLoadingMsg('กำลังบูตเครื่อง AI ครั้งแรก (อาจใช้เวลา 1-3 นาที)... 🚀');
                        }

                    } catch (err) {
                        console.warn("⚠️ กระตุกระหว่างเช็กสถานะ (รอเช็กใหม่รอบหน้า):", err);
                        errorCount++;
                        if (errorCount >= 10) {
                            throw new Error("สูญเสียการเชื่อมต่อกับเซิร์ฟเวอร์ กรุณาลองใหม่อีกครั้ง");
                        }
                    }
                }
            }

            setLoadingMsg('กำลังประกอบภาพขั้นสุดท้าย... 🖼️');
            const finalImageUrl = prediction.resultImage || prediction.output;

            if (!finalImageUrl) throw new Error("ไม่พบรูปภาพผลลัพธ์จากระบบ");

            await generateFinalImage(finalImageUrl);

        } catch (error) {
            console.error("Frontend API Error:", error);
            alert(`เกิดข้อผิดพลาด: ${error.message}`);
            setStep('upload');
        }
    };

    const generateFinalImage = async (swappedImageUrl) => {
        try {
            const canvas = document.createElement('canvas');
            const canvasWidth = 1080;
            const canvasHeight = 1920;
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            const ctx = canvas.getContext('2d');

            const resultImg = new Image();
            resultImg.crossOrigin = "Anonymous";
            resultImg.src = swappedImageUrl;
            await new Promise((resolve) => { resultImg.onload = resolve; });

            ctx.drawImage(resultImg, 0, 0, canvasWidth, canvasHeight);

            const fontSize = Math.max(30, Math.floor(canvasWidth * 0.035));
            ctx.font = `bold ${fontSize}px sans-serif`;
            ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
            ctx.shadowColor = "rgba(0, 0, 0, 0.8)";
            ctx.shadowBlur = 8;
            ctx.shadowOffsetX = 2;
            ctx.shadowOffsetY = 2;

            const padding = 40;
            ctx.textAlign = "left";
            ctx.textBaseline = "top";
            ctx.fillText("หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่", padding, padding);

            ctx.textAlign = "right";
            ctx.textBaseline = "bottom";
            ctx.fillText("#ภูมิใจแต่งไทยทั้งแผ่นดิน", canvas.width - padding, canvas.height - padding);

            const finalDataUrl = canvas.toDataURL('image/jpeg', 0.95);
            setFinalImage(finalDataUrl);
            setStep('result');

        } catch (error) {
            console.error("Error generating final image:", error);
            alert("เกิดข้อผิดพลาดในการประมวลผลภาพขั้นสุดท้าย");
            setStep('upload');
        }
    };

    const downloadFinalImage = async () => {
        if (!finalImage) return;

        try {
            const response = await fetch(finalImage);
            const blob = await response.blob();
            const filename = `SmartLibrary_ThaiDress_${new Date().getTime()}.jpg`;
            const file = new File([blob], filename, { type: 'image/jpeg' });

            // ใช้ Web Share API ถ้ารองรับ
            if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({
                    files: [file],
                    title: 'รูปภาพชุดไทยล้านนา',
                    text: 'เยือนเวียง แต่งไทย ณ หอสมุดแห่งชาติรัชมังคลาภิเษก เชียงใหม่ #ภูมิใจแต่งไทยทั้งแผ่นดิน'
                });
            } else {
                // Fallback สำหรับเบราว์เซอร์ที่ไม่รองรับ Share
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
            }
        } catch (error) {
            console.error("Share or Download failed:", error);
            // ไม่ต้อง alert ตรงนี้ เพราะมีข้อความแนะนำบน UI แล้ว
        }
    };

    const scrollSlider = (direction) => {
        if (sliderRef.current) {
            const scrollAmount = 280; 
            sliderRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="w-full h-[100dvh] overflow-y-auto overflow-x-hidden bg-stone-950 text-white font-sans flex flex-col relative scroll-smooth">
            <div className="sticky top-0 z-50 w-full">
                <SiteHeader />
            </div>

            <main className="flex-1 flex flex-col w-full relative">
                {['intro', 'howto', 'select'].includes(step) && (
                    <div className="absolute inset-0 z-0">
                        <img
                            src="/assets/bg-main.png"
                            alt="Background"
                            className="w-full h-full object-cover opacity-30"
                        />
                        <div className="absolute inset-0 bg-gradient-to-b from-stone-950/60 via-stone-900/80 to-stone-950"></div>
                    </div>
                )}

                {/* หน้าที่ 1: แนะนำการใช้งาน */}
                {step === 'intro' && (
                    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] p-6 text-center animate-fade-in relative z-10 mx-auto w-full max-w-md aspect-[9/16]">
                        <div className="mb-4 inline-block px-4 py-1.5 rounded-full bg-amber-500/20 border border-amber-500/30 text-amber-400 text-sm font-medium tracking-wide backdrop-blur-sm">
                            📸 AI Photo Booth
                        </div>
                        <h1 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-amber-200 to-amber-500 mb-2 drop-shadow-lg leading-tight">
                            เยือนเวียง<br />แต่งไทย
                        </h1>

                        <div className="bg-stone-900/40 backdrop-blur-md border border-stone-800/50 p-6 rounded-3xl w-full mb-6 shadow-2xl">
                            <p className="text-stone-300 text-base leading-relaxed mb-4">
                                ลองแปลงโฉมเป็นคุณในยุคอดีต ด้วยชุดไทยล้านนาและชุดไทยพระราชนิยมผ่าน AI
                            </p>
                            <div className="flex items-center justify-center gap-3 my-4 opacity-50">
                                <div className="h-px w-8 bg-amber-500"></div>
                                <span className="text-amber-500 text-xs">✦</span>
                                <div className="h-px w-8 bg-amber-500"></div>
                            </div>
                            <p className="text-amber-50/90 text-sm leading-relaxed font-light">
                                ลองแต่งรูปในนี้เสร็จแล้ว <strong className="text-amber-400 font-medium">อย่าลืมหาโอกาสมาเยือนเชียงใหม่ในสถานที่จริง</strong> <br />
                                ความสวยงามของจริง รอให้คุณมาสัมผัสด้วยตัวเองครับ 😊
                            </p>
                        </div>

                        {/* กล่องแจ้งเตือนเมื่อเปิดผ่านแอปแชท */}
                        {isInAppBrowser && (
                            <div className="w-full bg-red-950/60 border border-red-500/50 p-4 rounded-2xl mb-6 text-left shadow-lg backdrop-blur-md animate-pulse">
                                <p className="font-bold text-red-400 text-sm mb-1 flex items-center gap-2">
                                    <span className="text-lg">⚠️</span> ข้อควรระวัง
                                </p>
                                <p className="text-stone-300 text-xs leading-relaxed">
                                    คุณกำลังใช้งานผ่านแอปแชท ซึ่งอาจทำให้ <strong className="text-white">ไม่สามารถบันทึกรูปภาพได้</strong> 
                                </p>
                                <p className="text-amber-400 text-xs leading-relaxed mt-2 bg-black/30 p-2 rounded-lg">
                                    💡 แนะนำให้กดปุ่ม <strong>⋮</strong> หรือ <strong>⋯</strong> (มุมขวาบน) แล้วเลือก <br/>
                                    <strong>"เปิดในเบราว์เซอร์เริ่มต้น" (Open in Browser)</strong> เพื่อการใช้งานที่สมบูรณ์ครับ
                                </p>
                            </div>
                        )}

                        <button
                            onClick={() => setStep('howto')}
                            className="w-full py-4 bg-gradient-to-r from-amber-500 to-amber-400 text-stone-950 rounded-full font-bold text-lg shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:scale-105 transition-all active:scale-95"
                        >
                            ลองแต่งรูปกันเลย ✨
                        </button>
                    </div>
                )}

                {/* หน้าที่ 1.5: ขั้นตอนการใช้งาน */}
                {step === 'howto' && (
                    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] p-6 animate-fade-in relative z-10 mx-auto w-full max-w-md aspect-[9/16]">
                        <div className="text-center mb-6">
                            <h2 className="text-3xl font-bold text-amber-500 mb-2">ขั้นตอนการใช้งาน</h2>
                            <p className="text-stone-400 text-sm">ทำตาม 3 ขั้นตอนง่ายๆ</p>
                        </div>

                        <div className="w-full space-y-4 mb-8">
                            <div className="bg-stone-900/60 backdrop-blur-md border border-stone-800/50 p-5 rounded-2xl flex items-center gap-4">
                                <div className="text-4xl">👘</div>
                                <div>
                                    <h3 className="text-amber-400 font-bold text-lg">1. เลือกชุดและฉาก</h3>
                                    <p className="text-stone-400 text-sm mt-1">เลือกสไตล์ชุดและฉากหลังที่คุณชื่นชอบ</p>
                                </div>
                            </div>
                            <div className="bg-stone-900/60 backdrop-blur-md border border-stone-800/50 p-5 rounded-2xl flex items-center gap-4">
                                <div className="text-4xl">📸</div>
                                <div>
                                    <h3 className="text-amber-400 font-bold text-lg">2. อัปโหลดรูปภาพ</h3>
                                    <p className="text-stone-400 text-sm mt-1">เลือกรูปหน้าตรงที่เห็นใบหน้าชัดเจน</p>
                                </div>
                            </div>
                            <div className="bg-stone-900/60 backdrop-blur-md border border-stone-800/50 p-5 rounded-2xl flex items-center gap-4">
                                <div className="text-4xl">🪄</div>
                                <div>
                                    <h3 className="text-amber-400 font-bold text-lg">3. AI เนรมิตภาพ</h3>
                                    <p className="text-stone-400 text-sm mt-1">รอสักครู่ ระบบจะสลับใบหน้าให้อัตโนมัติและพร้อมดาวน์โหลดทันที</p>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={handleStartSelection}
                            className="w-full py-4 bg-gradient-to-r from-amber-500 to-amber-400 text-stone-950 rounded-xl font-bold text-lg shadow-[0_0_20px_rgba(245,158,11,0.3)] active:scale-95 transition-all"
                        >
                            เข้าใจแล้ว เริ่มเลย! ✨
                        </button>
                    </div>
                )}

                {/* หน้าที่ 2: เลือกสไตล์ */}
                {step === 'select' && (
                    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] pt-6 pb-12 animate-fade-in relative z-10 mx-auto w-full max-w-md aspect-[9/16]">
                        <div className="text-center mt-2 mb-6 px-4 w-full">
                            <h1 className="text-3xl font-bold text-amber-500 mb-2">เลือกสไตล์ชุดและฉาก</h1>
                            <p className="text-stone-400 text-sm mb-4">ปัดซ้าย-ขวา หรือกดปุ่ม เพื่อเลือกดูชุด</p>

                            <div className="flex bg-stone-900/60 backdrop-blur-md p-1 rounded-full border border-stone-800 mx-auto w-48">
                                <button
                                    onClick={() => setGenderFilter('female')}
                                    className={`flex-1 py-2 rounded-full text-sm font-bold transition-all ${genderFilter === 'female' ? 'bg-amber-500 text-stone-950' : 'text-stone-400'}`}
                                >
                                    หญิง
                                </button>
                                <button
                                    onClick={() => setGenderFilter('male')}
                                    className={`flex-1 py-2 rounded-full text-sm font-bold transition-all ${genderFilter === 'male' ? 'bg-amber-500 text-stone-950' : 'text-stone-400'}`}
                                >
                                    ชาย
                                </button>
                            </div>
                        </div>

                        <div className="relative w-full flex items-center justify-center px-2">
                            <button
                                onClick={() => scrollSlider('left')}
                                className="absolute left-0 z-30 w-10 h-10 bg-stone-900/80 backdrop-blur-md border border-amber-500/50 text-amber-500 rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(245,158,11,0.2)] hover:bg-amber-500 hover:text-stone-950 transition-all active:scale-95"
                            >
                                ◀
                            </button>

                            <div
                                ref={sliderRef}
                                className="w-full flex overflow-x-auto gap-4 snap-x snap-mandatory hide-scrollbar px-8 pb-8 pt-4 scroll-smooth"
                            >
                                {templates.filter(tpl => tpl.gender === genderFilter).map(tpl => (
                                    <div
                                        key={tpl.id}
                                        onClick={() => { setSelectedTpl(tpl); setStep('upload'); }}
                                        className="w-64 shrink-0 snap-center relative aspect-[9/16] bg-stone-800/80 backdrop-blur-sm rounded-3xl overflow-hidden cursor-pointer border-2 border-stone-700/50 hover:border-amber-500 transition-all group shadow-xl"
                                    >
                                        <div className="absolute inset-0 bg-gradient-to-b from-stone-700/50 to-stone-900/90 opacity-50 z-0"></div>
                                        <img
                                            src={tpl.image}
                                            className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform z-10"
                                            alt={tpl.name}
                                        />
                                        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black via-black/80 to-transparent pt-16 pb-6 px-4 z-20 text-center pointer-events-none">
                                            <p className="font-bold text-white text-lg drop-shadow-md">{tpl.name}</p>
                                            {tpl.locationName && <p className="text-stone-300 text-xs mt-1 drop-shadow-md">📍 {tpl.locationName}</p>}
                                            <p className="text-amber-400 text-xs mt-2 drop-shadow-md">แตะเพื่อเลือก</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <button
                                onClick={() => scrollSlider('right')}
                                className="absolute right-0 z-30 w-10 h-10 bg-stone-900/80 backdrop-blur-md border border-amber-500/50 text-amber-500 rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(245,158,11,0.2)] hover:bg-amber-500 hover:text-stone-950 transition-all active:scale-95"
                            >
                                ▶
                            </button>
                        </div>
                    </div>
                )}

                {/* หน้าที่ 3: อัปโหลดรูป */}
                {step === 'upload' && (
                    <div className="w-full min-h-[calc(100vh-80px)] flex flex-col justify-center items-center p-6">
                        <div className="text-center mb-8">
                            <h2 className="text-white font-bold text-2xl mb-2">อัปโหลดรูปหน้าตรงของคุณ</h2>
                        </div>
                        <label className="w-full max-w-sm aspect-square bg-stone-900 rounded-[2rem] border-4 border-dashed border-stone-600 flex flex-col items-center justify-center cursor-pointer hover:border-amber-500 transition-all">
                            <span className="text-6xl mb-4">📸</span>
                            <span className="text-amber-500 font-bold text-xl">เลือกรูปภาพ</span>
                            <input type="file" accept="image/jpeg, image/png" className="hidden" onChange={handleImageUpload} />
                        </label>
                    </div>
                )}

                {/* Loading Face Swap & Mini Game */}
                {step === 'processing' && (
                    <div className="fixed inset-0 z-[60] bg-stone-950 flex flex-col items-center justify-center p-6 text-center">
                        <div className="relative w-20 h-20 mb-6">
                            <div className="absolute inset-0 border-4 border-stone-800 rounded-full"></div>
                            <div className="absolute inset-0 border-4 border-t-amber-500 border-r-pink-500 border-transparent rounded-full animate-spin"></div>
                        </div>
                        <h3 className="text-2xl font-bold text-amber-500 animate-pulse mb-3">
                            {loadingMsg}
                        </h3>
                        <p className="text-stone-400 text-sm mb-6 max-w-sm">
                            ระหว่างรอ ลองมาจับโคมลอยเล่นกันเถอะ!
                        </p>

                        {/* --- เริ่มต้น UI มินิเกม --- */}
                        <div className="w-full max-w-sm bg-stone-900/60 backdrop-blur-md border border-stone-800 rounded-2xl p-4 shadow-xl select-none">
                            <div className="flex justify-between items-center mb-3">
                                <span className="text-stone-300 font-medium">คะแนนโคมลอย:</span>
                                <span className="bg-amber-500 text-stone-950 font-bold px-4 py-1 rounded-full text-lg">
                                    {score} 🏮
                                </span>
                            </div>

                            {/* กรอบเล่นเกม */}
                            <div className="relative w-full h-48 bg-stone-950/80 rounded-xl overflow-hidden border border-stone-700/50 cursor-crosshair">
                                <button
                                    onClick={handleCatchLantern}
                                    className="absolute text-5xl transition-all duration-300 ease-in-out hover:scale-110 active:scale-75"
                                    style={{
                                        top: targetPos.top,
                                        left: targetPos.left,
                                        transform: 'translate(-50%, -50%)'
                                    }}
                                >
                                    🏮
                                </button>
                                <div className="absolute bottom-2 inset-x-0 text-center pointer-events-none">
                                    <span className="text-stone-600 text-xs">แตะที่โคมลอยเพื่อเก็บคะแนน</span>
                                </div>
                            </div>
                        </div>
                        {/* --- จบ UI มินิเกม --- */}
                    </div>
                )}

                {/* หน้าที่ 4: ผลลัพธ์ */}
                {step === 'result' && (
                    <div className="w-full flex flex-col items-center p-6 pb-12 relative z-10 mx-auto max-w-md">
                        <h2 className="text-3xl font-bold text-amber-500 mb-6">เสร็จสมบูรณ์! 🎉</h2>

                        {score > 0 && (
                            <div className="mb-4 bg-amber-500/20 border border-amber-500/50 text-amber-400 px-4 py-2 rounded-full text-sm font-medium">
                                คุณเก็บโคมลอยไปได้ทั้งหมด {score} ดวง! 🏮
                            </div>
                        )}

                        <div className="w-full">
                            <div className="relative w-full aspect-[9/16] max-h-[60vh] rounded-2xl overflow-hidden shadow-[0_10px_30px_rgba(245,158,11,0.2)] border-2 border-stone-800 bg-black mb-6 flex justify-center items-center">
                                <img src={finalImage} alt="Final Result" className="w-auto h-full max-w-full object-contain" />
                            </div>

                            <div className="flex flex-col gap-3 w-full">
                                <button onClick={downloadFinalImage} className="w-full py-4 bg-gradient-to-r from-amber-500 to-amber-400 rounded-xl text-stone-950 font-bold text-lg shadow-lg active:scale-95 transition-transform flex items-center justify-center gap-2">
                                    <span className="text-2xl">⬇️</span> บันทึกรูปลงเครื่อง / แชร์
                                </button>
                                
                                <p className="text-stone-400 text-sm text-center mt-1 px-2 mb-2">
                                    💡 หากปุ่มไม่ทำงาน <strong className="text-amber-500">กรุณากดค้างที่รูปภาพ</strong> เพื่อบันทึกลงเครื่อง
                                </p>

                                {selectedTpl && selectedTpl.mapUrl && (
                                    <a
                                        href={selectedTpl.mapUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-full py-4 bg-blue-600/20 text-blue-400 border border-blue-600/50 hover:bg-blue-600/40 rounded-xl font-bold text-base active:scale-95 transition-all flex items-center justify-center gap-2"
                                    >
                                        📍 เปิดแผนที่ {selectedTpl.locationName || 'เชียงใหม่'}
                                    </a>
                                )}

                                <button onClick={() => {
                                    setStep('intro');
                                    setUserImage(null);
                                    setFinalImage(null);
                                    setScore(0); 
                                }} className="w-full py-4 mt-2 bg-stone-800 text-stone-300 rounded-xl font-bold border border-stone-700 hover:bg-stone-700 active:scale-95 transition-all">
                                    เริ่มต้นใหม่
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </main>

            <style dangerouslySetInnerHTML={{
                __html: `
                .hide-scrollbar::-webkit-scrollbar { display: none; }
                .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
            `}} />
        </div>
    );
};

export default FaceSwapPhotoBooth;